import PropTypes from 'prop-types';
import React from 'react';
import styles from './RefundReason.css';

class RefundReason extends React.Component {
  render() {
    const { paymentRefund } = this.props;

    // noinspection JSUnresolvedVariable
    return (
      <div className={styles['receipt-refund-reason']}>
        <div className="row">
          <div className="col-md-6 col-xs-8" style={{ textAlign: 'left' }}>
            Reason for Refund
          </div>
          <div className="col-md-6 col-xs-4">
            <div className={`${styles['truncate-refund-reason']} pull-right`}>
              {paymentRefund.refunded_reason}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RefundReason.propTypes = {
  paymentRefund: PropTypes.object,
};

export default RefundReason;
